import type {
  BadgeVariant,
  ButtonIconPlacement,
  ButtonSize,
  ButtonVariant,
} from '@property.com.au/ui-kit';
import { Badge, Button, paletteHelper, spacingHelper } from '@property.com.au/ui-kit';
import type { FunctionComponent, ReactNode } from 'react';
import styled from 'styled-components';
import { CommuteSearchCTAImage } from './CommuteSearchCTAImage';

export interface CommuteSearchCTAButtonProps {
  text: string;
  variant: ButtonVariant;
  sizeVariant: ButtonSize;
  iconPlacement?: ButtonIconPlacement;
  icon: ReactNode;
  callout: {
    text: string;
    badgeVariant?: BadgeVariant;
  };
  onClick: () => void;
}

const CTA_IMAGE_HEIGHT = 116;

const CommuteSearchCTAWrapper = styled.div`
  width: 100%;
  position: relative;
  overflow: hidden;
  height: ${CTA_IMAGE_HEIGHT}px;
  display: flex;
  justify-content: center;
  border-radius: ${spacingHelper('extraSmall')};
  border: 2px solid ${paletteHelper('borderBrandStatic')};
  margin-top: ${spacingHelper('large')};
`;

const StyledCommuteSearchCTAImage = styled(CommuteSearchCTAImage)`
  flex-shrink: 0;
  cursor: pointer;
`;

const StyledCommuteSearchCTAButton = styled(Button)`
  position: absolute;
  bottom: ${spacingHelper('extraSmall')};
  left: 50%;
  transform: translateX(-50%);
  padding: ${spacingHelper('extraSmall small')};
  background: linear-gradient(
    75deg,
    rgb(228 0 43 / 100%) 0%,
    rgb(136 0 178 / 100%) 51%,
    rgb(228 0 43 / 100%) 100%
  );
  background-color: ${paletteHelper('backgroundPrimary')};
  span {
    display: flex;
    flex-shrink: 0;
    white-space: nowrap;
  }
  background-size: 200% auto;
  transition: background-position 0.75s;
  color: ${paletteHelper('textInverted')};
  border: none;
  &:hover {
    background-position: right center;
    color: ${paletteHelper('textInverted')};
    border: none;
  }
  &:active {
    background: ${paletteHelper('backgroundPressedBrandStatic')};
  }
  &:focus {
    color: ${paletteHelper('textInverted')};
    border: ${paletteHelper('borderFocused')};
  }
`;

const CalloutBadge = styled(Badge)`
  margin: ${spacingHelper('0 extraSmall 0 0')};
  padding: ${spacingHelper('0 extraSmall')};
`;

export const CommuteSearchCTAButton: FunctionComponent<CommuteSearchCTAButtonProps> = ({
  text,
  variant,
  sizeVariant,
  iconPlacement,
  icon,
  callout,
  onClick,
}) => {
  return (
    <CommuteSearchCTAWrapper onClick={onClick}>
      <StyledCommuteSearchCTAImage className="" />
      <StyledCommuteSearchCTAButton
        type="button"
        variant={variant}
        sizeVariant={sizeVariant}
        icon={icon}
        iconPlacement={iconPlacement}
      >
        <CalloutBadge variant={callout.badgeVariant} sizeVariant="extraSmall">
          {callout.text}
        </CalloutBadge>
        {text}
      </StyledCommuteSearchCTAButton>
    </CommuteSearchCTAWrapper>
  );
};
